import withGoogleApi from "./withGoogleApi";

export default function withMyGoogleApi(WrappedComponent) {
  return withGoogleApi(
    WrappedComponent,
    "AIzaSyCflSoSYHKRJZtN66t1SrasFl0_uHNUMjk"
  );
}
